/* global window */
'use strict';
const onReady = require('public/js/lib/on-ready');

const wishlist = {};

wishlist.addItem = function (evt) {
	evt.preventDefault();
	const $link = rp$(this);
	$link.addClass('loading');

	$ajax({
		method: 'POST',
		dataType: 'json',
		url: '/ajax/wishlist/add',
		data: $link.data(),
		success: (response, status/*, xhr*/) => {
			if (status === 'success') {
				// Send a quick Enhanced Ecommerce event
				const productDetails = wishlist.getProductDetailsFromWishlistElement($link);
				rp_app.track.track_ec_cart_event('add to wishlist', productDetails);
				$link.addClass('hide').removeClass('loading');
				$link.parent().find('.added-to-wishlist').addClass('show');
			}
		}
	});
};

wishlist.removeItem = function (evt) {
	evt.preventDefault();
	const $link = rp$(this);
	$link.addClass('loading');
	// Need to do a quick wait to give the loading animation time to show up before the confirm modal appears.
	setTimeout(() => {
		const confirmMessage = $link.data('confirm') || 'Are you sure?';
		const confirmation = window.confirm(confirmMessage);

		if(!confirmation) {
			$link.removeClass('loading');
			return;
		}

		$ajax({
			method: 'POST',
			dataType: 'json',
			url: '/ajax/wishlist/remove',
			data: $link.data(),
			success: (response, status/*, xhr*/) => {
				if (status === 'success') {
					// Send a quick Enhanced Ecommerce event
					const productDetails = wishlist.getProductDetailsFromWishlistElement($link);
					rp_app.track.track_ec_cart_event('remove from wishlist', productDetails);
					$link.closest('.catalog-product').remove();
					// If all catalog Products removed reload page to show empty message.
					if (rp$('.catalog-product').length === 0){
						rp_app.location.reload();
					}
				}
			}
		});

	});
};

wishlist.removeAll = function (evt) {
	evt.preventDefault();
	const $link = rp$(this);
	const confirmMessage = $link.data('confirm') || 'Are you sure?';
	const confirmation = window.confirm(confirmMessage);
	if(!confirmation) { return; }

	$ajax({
		method: 'POST',
		dataType: 'json',
		url: '/ajax/wishlist/empty',
		data: {
			cart_type: $link.data('cart-type'),
		},
		success: (response, status/*, xhr*/) => {
			if (status === 'success') {
				rp_app.track.track_ec_cart_event('empty wishlist');
				rp_app.location.reload();
			}
		}
	});
};

wishlist.getProductDetailsFromWishlistElement = function($element) {
	return {
		id: $element.data('sku-stripped'),
		cart_type: $element.data('cart_type'),
		name: $element.data('name'),
		brand: $element.data('brand'),
		price: Number($element.data('price')) || null,
		quantity: $element.data('quantity'),
	};
};

wishlist.attachEvents =  function () {
	rp$('.add-to-wishlist').on('click', wishlist.addItem);
	rp$('.remove-from-wishlist').on('click', wishlist.removeItem);
	rp$('.remove-all-from-wishlist').on('click', wishlist.removeAll);
};

onReady({rp$, window,
	label: 'wishlist',
	fn: wishlist.attachEvents
});

module.exports = wishlist;